
webpack.register(
    'components/image-universal/image-universal',
    function() {
        return require('components/image-universal/image-universal');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/image-universal/image-universal'/>\r\n\r\n<div class=\"c-card c-card__content c-card__content--info\">\r\n    {{#if image}}\r\n        <div class=\"s-image-box\">\r\n            <image-universal class-name=\"s-image-box__img\" {image}='image' />\r\n        </div>\r\n    {{/if}}\r\n    <div class=\"s-text-box\">\r\n        <div class=\"s-title\">{{title}}</div>\r\n        <div class=\"s-description\">{{{htmlDescription}}}</div>\r\n    </div>\r\n</div>");